
import { useEffect, useState } from 'react';
import { getBilling, getSubscription } from '../api.js';
import CommercialDashboard from './CommercialDashboard.jsx';
import PaymentChoice from './PaymentChoice.jsx';

export default function BillingDashboard(props) {
  const [state, setState] = useState({
    loading: true,
    error: false,
  });

  useEffect(() => {
    let active = true;

    async function update() {
      try {
        const [billing, usage] = await Promise.all([
          getBilling(),
          getSubscription(),
        ]);

        if (!active) return;

        const expiry = billing?.paid_until
          ? Date.parse(billing.paid_until)
          : 0;

        const legacy =
          billing?.status === 'active' &&
          billing?.is_legacy_subscription === true;

        const allowed =
          billing?.status === 'active' &&
          (legacy || expiry > Date.now());

        const internal =
          allowed &&
          Number(usage?.price_per_channel_rub_month) === 0 &&
          Boolean(billing?.paid_until);

        setState({
          loading: false,
          error: false,
          allowed,
          internal,
          limit: billing?.channel_limit ?? 0,
        });
      } catch {
        if (active) {
          setState({
            loading: false,
            error: true,
          });
        }
      }
    }

    update();

    const timer = setInterval(update, 5000);

    return () => {
      active = false;
      clearInterval(timer);
    };
  }, []);

  if (state.loading) {
    return (
      <section className="mf-billing">
        <p>Проверяем подписку…</p>
      </section>
    );
  }

  if (state.error) {
    return (
      <section className="mf-billing">
        <h2>Не удалось проверить подписку</h2>
        <p>Обновите страницу или повторите попытку позже.</p>
      </section>
    );
  }

  if (!state.allowed) {
    return <PaymentChoice />;
  }

  return (
    <>
      {state.internal && (
        <section className="mf-billing">
          <h2>Внутренняя лицензия «Связки»</h2>
          <p>
            Действует до 31 декабря 2049 года.
            Лимит: {state.limit} каналов.
          </p>
        </section>
      )}

      <CommercialDashboard {...props} />

      <PaymentChoice internal={state.internal} />
    </>
  );
}
